"use strict";
/**
 * Unless explicitly stated otherwise all files in this repository are licensed under the Apache-2.0 License.
 * This product includes software developed at Datadog (https://www.datadoghq.com/).
 * Copyright 2020-Present Datadog, Inc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyUsageAttributionValues = void 0;
/**
 * Fields in Usage Summary by tag(s).
 */
class MonthlyUsageAttributionValues {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return MonthlyUsageAttributionValues.attributeTypeMap;
    }
}
exports.MonthlyUsageAttributionValues = MonthlyUsageAttributionValues;
/**
 * @ignore
 */
MonthlyUsageAttributionValues.attributeTypeMap = {
    apiPercentage: {
        baseName: "api_percentage",
        type: "number",
        format: "double",
    },
    apiUsage: {
        baseName: "api_usage",
        type: "number",
        format: "double",
    },
    apmFargatePercentage: {
        baseName: "apm_fargate_percentage",
        type: "number",
        format: "double",
    },
    apmFargateUsage: {
        baseName: "apm_fargate_usage",
        type: "number",
        format: "double",
    },
    apmHostPercentage: {
        baseName: "apm_host_percentage",
        type: "number",
        format: "double",
    },
    apmHostUsage: {
        baseName: "apm_host_usage",
        type: "number",
        format: "double",
    },
    appsecFargatePercentage: {
        baseName: "appsec_fargate_percentage",
        type: "number",
        format: "double",
    },
    appsecFargateUsage: {
        baseName: "appsec_fargate_usage",
        type: "number",
        format: "double",
    },
    appsecPercentage: {
        baseName: "appsec_percentage",
        type: "number",
        format: "double",
    },
    appsecUsage: {
        baseName: "appsec_usage",
        type: "number",
        format: "double",
    },
    browserPercentage: {
        baseName: "browser_percentage",
        type: "number",
        format: "double",
    },
    browserUsage: {
        baseName: "browser_usage",
        type: "number",
        format: "double",
    },
    containerExclAgentPercentage: {
        baseName: "container_excl_agent_percentage",
        type: "number",
        format: "double",
    },
    containerExclAgentUsage: {
        baseName: "container_excl_agent_usage",
        type: "number",
        format: "double",
    },
    containerPercentage: {
        baseName: "container_percentage",
        type: "number",
        format: "double",
    },
    containerUsage: {
        baseName: "container_usage",
        type: "number",
        format: "double",
    },
    cspmContainersPercentage: {
        baseName: "cspm_containers_percentage",
        type: "number",
        format: "double",
    },
    cspmContainersUsage: {
        baseName: "cspm_containers_usage",
        type: "number",
        format: "double",
    },
    cspmHostsPercentage: {
        baseName: "cspm_hosts_percentage",
        type: "number",
        format: "double",
    },
    cspmHostsUsage: {
        baseName: "cspm_hosts_usage",
        type: "number",
        format: "double",
    },
    customIngestedTimeseriesPercentage: {
        baseName: "custom_ingested_timeseries_percentage",
        type: "number",
        format: "double",
    },
    customIngestedTimeseriesUsage: {
        baseName: "custom_ingested_timeseries_usage",
        type: "number",
        format: "double",
    },
    customTimeseriesPercentage: {
        baseName: "custom_timeseries_percentage",
        type: "number",
        format: "double",
    },
    customTimeseriesUsage: {
        baseName: "custom_timeseries_usage",
        type: "number",
        format: "double",
    },
    cwsContainersPercentage: {
        baseName: "cws_containers_percentage",
        type: "number",
        format: "double",
    },
    cwsContainersUsage: {
        baseName: "cws_containers_usage",
        type: "number",
        format: "double",
    },
    cwsHostsPercentage: {
        baseName: "cws_hosts_percentage",
        type: "number",
        format: "double",
    },
    cwsHostsUsage: {
        baseName: "cws_hosts_usage",
        type: "number",
        format: "double",
    },
    dbmHostsPercentage: {
        baseName: "dbm_hosts_percentage",
        type: "number",
        format: "double",
    },
    dbmHostsUsage: {
        baseName: "dbm_hosts_usage",
        type: "number",
        format: "double",
    },
    dbmQueriesPercentage: {
        baseName: "dbm_queries_percentage",
        type: "number",
        format: "double",
    },
    dbmQueriesUsage: {
        baseName: "dbm_queries_usage",
        type: "number",
        format: "double",
    },
    estimatedIndexedLogsPercentage: {
        baseName: "estimated_indexed_logs_percentage",
        type: "number",
        format: "double",
    },
    estimatedIndexedLogsUsage: {
        baseName: "estimated_indexed_logs_usage",
        type: "number",
        format: "double",
    },
    estimatedIndexedSpansPercentage: {
        baseName: "estimated_indexed_spans_percentage",
        type: "number",
        format: "double",
    },
    estimatedIndexedSpansUsage: {
        baseName: "estimated_indexed_spans_usage",
        type: "number",
        format: "double",
    },
    estimatedIngestedLogsPercentage: {
        baseName: "estimated_ingested_logs_percentage",
        type: "number",
        format: "double",
    },
    estimatedIngestedLogsUsage: {
        baseName: "estimated_ingested_logs_usage",
        type: "number",
        format: "double",
    },
    estimatedIngestedSpansPercentage: {
        baseName: "estimated_ingested_spans_percentage",
        type: "number",
        format: "double",
    },
    estimatedIngestedSpansUsage: {
        baseName: "estimated_ingested_spans_usage",
        type: "number",
        format: "double",
    },
    estimatedRumSessionsPercentage: {
        baseName: "estimated_rum_sessions_percentage",
        type: "number",
        format: "double",
    },
    estimatedRumSessionsUsage: {
        baseName: "estimated_rum_sessions_usage",
        type: "number",
        format: "double",
    },
    fargatePercentage: {
        baseName: "fargate_percentage",
        type: "number",
        format: "double",
    },
    fargateUsage: {
        baseName: "fargate_usage",
        type: "number",
        format: "double",
    },
    functionsPercentage: {
        baseName: "functions_percentage",
        type: "number",
        format: "double",
    },
    functionsUsage: {
        baseName: "functions_usage",
        type: "number",
        format: "double",
    },
    infraHostPercentage: {
        baseName: "infra_host_percentage",
        type: "number",
        format: "double",
    },
    infraHostUsage: {
        baseName: "infra_host_usage",
        type: "number",
        format: "double",
    },
    invocationsPercentage: {
        baseName: "invocations_percentage",
        type: "number",
        format: "double",
    },
    invocationsUsage: {
        baseName: "invocations_usage",
        type: "number",
        format: "double",
    },
    npmHostPercentage: {
        baseName: "npm_host_percentage",
        type: "number",
        format: "double",
    },
    npmHostUsage: {
        baseName: "npm_host_usage",
        type: "number",
        format: "double",
    },
    obsPipelineBytesPercentage: {
        baseName: "obs_pipeline_bytes_percentage",
        type: "number",
        format: "double",
    },
    obsPipelineBytesUsage: {
        baseName: "obs_pipeline_bytes_usage",
        type: "number",
        format: "double",
    },
    profiledContainerPercentage: {
        baseName: "profiled_container_percentage",
        type: "number",
        format: "double",
    },
    profiledContainerUsage: {
        baseName: "profiled_container_usage",
        type: "number",
        format: "double",
    },
    profiledFargatePercentage: {
        baseName: "profiled_fargate_percentage",
        type: "number",
        format: "double",
    },
    profiledFargateUsage: {
        baseName: "profiled_fargate_usage",
        type: "number",
        format: "double",
    },
    profiledHostPercentage: {
        baseName: "profiled_host_percentage",
        type: "number",
        format: "double",
    },
    profiledHostUsage: {
        baseName: "profiled_host_usage",
        type: "number",
        format: "double",
    },
    snmpPercentage: {
        baseName: "snmp_percentage",
        type: "number",
        format: "double",
    },
    snmpUsage: {
        baseName: "snmp_usage",
        type: "number",
        format: "double",
    },
    universalServiceMonitoringPercentage: {
        baseName: "universal_service_monitoring_percentage",
        type: "number",
        format: "double",
    },
    universalServiceMonitoringUsage: {
        baseName: "universal_service_monitoring_usage",
        type: "number",
        format: "double",
    },
    vulnManagementHostsPercentage: {
        baseName: "vuln_management_hosts_percentage",
        type: "number",
        format: "double",
    },
    vulnManagementHostsUsage: {
        baseName: "vuln_management_hosts_usage",
        type: "number",
        format: "double",
    },
};
//# sourceMappingURL=MonthlyUsageAttributionValues.js.map